import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "basic"
}, [
  /*#__PURE__*/_createVNode("a", { href: "#basic" }),
  /*#__PURE__*/_createTextVNode(" Basic Example ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Click the below toggle button to see a slightly customized modal with custom close icon button. ", -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_1"
}, " Launch demo modal ", -1)
const _hoisted_7 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_1"
}
const _hoisted_8 = { class: "modal-dialog" }
const _hoisted_9 = { class: "modal-content" }
const _hoisted_10 = { class: "modal-header" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Modal title", -1)
const _hoisted_12 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_13 = { class: "svg-icon svg-icon-2x" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "modal-body" }, [
  /*#__PURE__*/_createVNode("p", null, "Modal body text goes here.")
], -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-light",
    "data-bs-dismiss": "modal"
  }, " Close "),
  /*#__PURE__*/_createVNode("button", {
    type: "button",
    class: "btn btn-primary"
  }, " Save changes ")
], -1)
const _hoisted_16 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _hoisted_11,
                _createVNode("div", _hoisted_12, [
                  _createVNode("span", _hoisted_13, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
                  ])
                ])
              ]),
              _hoisted_14,
              _hoisted_15
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode(_component_CodeHighlighter, {
        fieldHeight: 400,
        lang: "html"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<button
          type="button"
          class="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#kt_modal_1"
        >
          Launch demo modal
        </button>

        <div class="modal fade" tabindex="-1" id="kt_modal_1">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Modal title</h5>

                <!--begin::Close-->
                <div
                  class="btn btn-icon btn-sm btn-active-light-primary ms-2"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span class="svg-icon svg-icon-2x"></span>
                </div>
                <!--end::Close-->
              </div>

              <div class="modal-body">
                <p>Modal body text goes here.</p>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-light"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" class="btn btn-primary">
                  Save changes
                </button>
              </div>
            </div>
          </div>
        </div>
        `), 1)
        ]),
        _: 1
      })
    ])
  ]))
}